export default __webpack_public_path__ + "static/PANASAS_Incorrect-Use-E-c2c8d2a6c8d15547def1c360f77ebff0.jpg";